import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { getMyProfile, updateMyLabels } from "../lib/profile";
import { enablePushOnThisDevice } from "../lib/push";

export default function Settings() {
  const [email, setEmail] = useState("");
  const [myLabel, setMyLabel] = useState("Me");
  const [partnerLabel, setPartnerLabel] = useState("Partner");
  const [status, setStatus] = useState("");
  const [saving, setSaving] = useState(false);

  const [pushStatus, setPushStatus] = useState("");
  const [pushBusy, setPushBusy] = useState(false);

  async function load() {
    setStatus("");
    const { data: userData } = await supabase.auth.getUser();
    setEmail(userData?.user?.email || "");

    const { data, error } = await getMyProfile();
    if (error) return setStatus(error.message || "Failed to load profile.");
    if (data?.my_label) setMyLabel(data.my_label);
    if (data?.partner_label) setPartnerLabel(data.partner_label);
  }

  useEffect(() => {
    load();
  }, []);

  async function save() {
    setSaving(true);
    setStatus("");
    const { error } = await updateMyLabels({ my_label: myLabel, partner_label: partnerLabel });
    setSaving(false);
    if (error) return setStatus(error.message || "Failed to save.");
    setStatus("Saved.");
    window.setTimeout(() => setStatus(""), 1200);
  }

  async function signOut() {
    await supabase.auth.signOut();
    window.location.reload();
  }

  return (
    <div style={{ display: "grid", gap: 14 }}>
      <h2 style={{ margin: 0 }}>Settings</h2>

      <div style={card}>
        <div style={{ fontWeight: 900 }}>Account</div>
        <div style={{ marginTop: 10, fontSize: 13, opacity: 0.85 }}>
          Signed in as: <b>{email}</b>
        </div>
        <button style={{ ...btn, marginTop: 12 }} onClick={signOut}>
          Sign out
        </button>
      </div>

      <div style={card}>
        <div style={{ fontWeight: 900 }}>Labels</div>
        <div style={{ marginTop: 6, fontSize: 13, opacity: 0.75 }}>
          These change what the timeline calls you and your partner on this account.
        </div>

        <label style={{ display: "grid", gap: 6, marginTop: 12 }}>
          <span style={label}>Your label</span>
          <input style={input} value={myLabel} onChange={(e) => setMyLabel(e.target.value)} maxLength={30} />
        </label>

        <label style={{ display: "grid", gap: 6, marginTop: 12 }}>
          <span style={label}>Partner label</span>
          <input style={input} value={partnerLabel} onChange={(e) => setPartnerLabel(e.target.value)} maxLength={30} />
        </label>

        <div style={{ marginTop: 10, fontSize: 13, opacity: 0.8 }}>
          Preview: <b>{myLabel || "Me"}</b> and <b>{partnerLabel || "Partner"}</b>
        </div>

        <button style={{ ...btn, marginTop: 12, opacity: saving ? 0.6 : 1 }} onClick={save} disabled={saving}>
          {saving ? "Saving..." : "Save labels"}
        </button>

        {status ? <div style={{ marginTop: 10, fontSize: 13, opacity: 0.85 }}>{status}</div> : null}

        <div style={{ marginTop: 14, borderTop: "1px solid rgba(255,255,255,0.10)", paddingTop: 12 }}>
          <div style={{ fontWeight: 900 }}>Push notifications</div>
          <div style={{ marginTop: 6, fontSize: 13, opacity: 0.75 }}>
            Enable push on this device. Partner-only notifications.
          </div>

          <button
            style={{ ...btn, marginTop: 12, opacity: pushBusy ? 0.6 : 1 }}
            disabled={pushBusy}
            onClick={async () => {
              setPushBusy(true);
              setPushStatus("");
              const { error } = await enablePushOnThisDevice();
              setPushBusy(false);
              if (error) return setPushStatus(error.message || "Failed to enable push.");
              setPushStatus("Push enabled on this device.");
            }}
          >
            {pushBusy ? "Enabling..." : "Enable push on this device"}
          </button>

          {pushStatus ? <div style={{ marginTop: 10, fontSize: 13, opacity: 0.85 }}>{pushStatus}</div> : null}
        </div>
      </div>

      <div style={card}>
        <div style={{ fontWeight: 900 }}>Reminder help</div>
        <div style={{ marginTop: 6, fontSize: 13, opacity: 0.75 }}>
          For MVP, reminders stay local on your iPhone using the Reminders or Calendar app.
        </div>
      </div>
    </div>
  );
}

const card = {
  padding: 12,
  borderRadius: 16,
  border: "1px solid rgba(255,255,255,0.12)",
  background: "rgba(255,255,255,0.05)",
};

const btn = {
  padding: "10px 12px",
  borderRadius: 12,
  border: "1px solid rgba(255,255,255,0.14)",
  background: "transparent",
  color: "white",
  cursor: "pointer",
  fontWeight: 900,
};

const label = { fontSize: 12, opacity: 0.75 };

const input = {
  padding: "10px 12px",
  borderRadius: 12,
  border: "1px solid rgba(255,255,255,0.14)",
  background: "transparent",
  color: "white",
  outline: "none",
};
